// MyRedPark legal / company configuration — single source of truth for the
// website. All values below are owner-provided and final (2026-09-06); the
// isMissing/legalValue helpers remain as a safety net for any future field
// that must not be invented.
//
// Verified corporate information (provided by the owner, 2026-09):
//   Zopytech Ltd. · incorporated 2026-06-08 under the Canada Business
//   Corporations Act (CBCA) · registered office in Ontario.
// The corporation number is CONFIDENTIAL and must never appear in any
// customer-facing surface (owner directive 2026-10-14). Personal information
// from the incorporation record (directors, addresses, signatures) is
// deliberately NOT used anywhere.

export const LEGAL = {
  brand: "MyRedPark",
  tagline: "Your Spot. Your Way.",
  operator: "Zopytech Ltd.",
  operatorLine: "MyRedPark is operated by Zopytech Ltd., a corporation incorporated under the Canada Business Corporations Act (CBCA).",
  copyright: "© 2026 Zopytech Ltd. All rights reserved.",
  poweredBy: "MyRedPark — Operated by Zopytech Ltd.",

  companyLegalName: "Zopytech Ltd.",
  incorporation: "Incorporated under the Canada Business Corporations Act (CBCA) on June 8, 2026. Registered office: Province of Ontario, Canada.",

  // Contact + jurisdiction (owner-provided, 2026-09-06): Canada-based company,
  // single contact channel for all legal/privacy/support inquiries.
  companyAddress: "Ontario, Canada",
  governingLaw: "Canada",
  disputeVenue: "Courts of Canada",

  legalEmail: "support@zopytech.com",
  privacyEmail: "support@zopytech.com",
  supportEmail: "support@zopytech.com",

  effectiveDate: "October 14, 2026",
  version: "2.0",
};

export const isMissing = (v) => !v || String(v).startsWith("TODO_") || String(v).startsWith("[");

// Renders a legal value or a clearly visible pending marker.
export const legalValue = (v) =>
  isMissing(v) ? "⚠ PENDING — to be provided before launch" : v;
